import pluralize from "@/lib/pluralize";

export function finalizePartialFailureMessage(successfulCount: number): string {
  const personLabel = pluralize(successfulCount, "person", undefined, "people");
  return `Finalized elections for ${successfulCount} ${personLabel}. Some applications could not be elected.`;
}

export function finalizeAllFailedMessage(): string {
  return "None of the selected applications could be elected.";
}

export function finalizeListRefreshErrorMessage(successfulCount: number): string {
  if (successfulCount > 0) {
    return "Elections were finalized, but the list could not be refreshed.";
  }

  return "The list could not be refreshed.";
}
